<template>
  <div class="pay">
    <fixed-header title="确认订单"></fixed-header>
    <div class="pay__main scroll-touch">
      <div
          v-if="showAddressFlag"
          :mg-stat-custom="'label=title&cont=点击地址&direct=web'"
          class="pay__address"
          mg-stat-click
          mg-stat-mod="pay_address"
          @click="gotoEdit"
      >
        <section v-if="hasAddress" class="pay__address-user">
          {{ nowAddress.consignee }}&nbsp;&nbsp;{{ nowAddress.mobile }}
        </section>
        <section class="pay__address-detail">
          <i class="icon position"></i>
          <div>{{ showAddress(nowAddress, "新增地址") }}</div>
          <i :class="['icon', hasAddress ? 'left_arrow' : 'address_add']"></i>
        </section>
        <p v-if="errorMsg" class="pay__address-error">{{ errorMsg }}</p>
      </div>
      <div class="pay__content">
        <div
            v-for="(item, index) in form.cartList"
            :key="index"
            class="pay__content-sku"
        >
          <section>
            <img :src="item.originalImg" alt/>
          </section>
          <section>
            <div>{{ item.goodsName }}</div>
            <div>{{ item.specKeyName }}</div>
            <goods-tags :tags="item.tags"></goods-tags>
            <div>
              <span>¥{{ getItemPrice(item) }}</span>
              <span>x{{ item.goodsNum }}</span>
            </div>
          </section>
        </div>
        <div v-if="preSellInfo" class="pay__presell-info">
          <p>
            <span>阶段一：付定金</span>
            <span>¥{{ preBuyDepositPrice }}</span>
          </p>
          <p>
            <span>阶段二：{{ preBuyTime }} 开始支付尾款</span>
            <span>¥{{ preBuyCutPrice }}</span>
          </p>
          <p v-for="(item, index) in preSellInfo.priceLadder" :key="index">
            <span>预售达{{ item.amount }}件 尾款优惠</span>
            <span>- ¥{{ getDiscountPrice(item.price) }}</span>
          </p>
        </div>
        <div class="pay__content-transway">
          <span>配送方式</span>
          <span>{{ getTransway(form.shippingPrice) }}</span>
        </div>
        <div
            v-if="showSelectCoupon"
            class="pay__content-coupon"
            mg-stat-mod="choose_coupon"
        >
          <div>
            <span>优惠券</span>
            <span v-if="couponId" class="checked">已选一张</span>
          </div>
          <div
              :mg-stat-custom="'label=title&cont=优惠券&direct=cntp'"
              mg-stat-click
              mg-stat-mod="pay_couponi"
              @click="showCoupon = true"
          >
            <span :class="{ active: hasCoupon && !couponPrice }">{{
                couponTip
              }}</span>
            <i class="icon left_arrow"></i>
          </div>
        </div>
        <div class="pay__content-remark">
          <div>买家留言</div>
          <div>
            <input
                :value="userNote"
                placeholder="选填"
                type="text"
                @focus="hasAnyAction = true"
                @input="changeUserNote($event.target.value)"
            />
          </div>
        </div>
        <div class="pay__content-price">
          <div>共计{{ form.goodsNum }}件商品</div>
        </div>
      </div>
      <div v-if="isBlindBoxGoods" class="pay__presell">
        <div class="pay__presell-tip" mg-stat-mod="rule_agree">
          <p>盲盒商品【不支持退款】</p>
          <p>
            <span>我已同意此规则</span>
            <my-switch
                :value="is_agree_box_rule"
                @change="
                (val) => {
                  changeBoxRule(val);
                }
              "
            ></my-switch>
          </p>
        </div>
      </div>
      <div v-if="preSellInfo" class="pay__presell">
        <div class="pay__presell-phone">
          <span>通知支付尾款手机号：</span>
          <input
              :value="noticeMobile"
              placeholder="选填"
              type="text"
              @input="changeMobile($event.target.value)"
          />
        </div>
        <div class="pay__presell-tip" mg-stat-mod="rule_agree">
          <p>预售失败，定金自动全额退还；预售成功，定金不退</p>
          <p>
            <span>我已同意此规则</span>
            <my-switch
                :value="is_agree_rule"
                @change="
                (val) => {
                  changePreRule(val);
                }
              "
            ></my-switch>
          </p>
        </div>
      </div>
      <ul class="pay__price">
        <li>
          <span>商品总价</span>
          <span>{{ orderGoodsTotalPrice }}</span>
        </li>
        <li v-if="showSelectCoupon" class="pay__price-coupon">
          <span>优惠</span>
          <span class="active">-¥{{ form.couponPrice }}</span>
        </li>
        <li>
          <span>运费</span>
          <span>¥{{ form.shippingPrice }}</span>
        </li>
        <li>
          <span>应付总额</span>
          <span class="active">{{ orderGoodsPaymentPrice }}</span>
        </li>
      </ul>
      <div class="pay__order-tip">
        <div>订单查询</div>
        <div v-if="fromJubaopen">芒果TV-聚宝盆-我的背包-兑换明细</div>
        <div v-else-if="form.integral">芒果TV App-个人中心-我的积分内查询订单</div>
        <div v-else>芒果TV App-个人中心-芒果好物内查询订单</div>
      </div>
      <div v-if="form.integral" class="pay__integral-tip">
        <div>{{coinName}}详情</div>
        <div>需要{{ form.integral }}{{coinName}}，当前您剩余{{ userIntegral }}{{coinName}}</div>
      </div>
    </div>
    <div class="pay__bottom">
      <div>
        总计：
        <span>{{ orderGoodsPaymentPrice }}</span>
      </div>
      <div v-if="showPayBtn"
           :mg-stat-lob="`couponid=${couponId}`"
           mg-stat-click
           mg-stat-custom="label=btn&cont=立即支付&direct=cntp"
           mg-stat-mod="confrim_payment"
           @click="readyPay"
      >
        立即支付
      </div>
      <div v-if="!showPayBtn">{{coinName}}不足</div>
    </div>
    <Pay
        :couponId="couponId"
        :goodsids="goodsids"
        :goodsidsAndNum="goodsidsAndNum"
        :isShow="isShowPay"
        :needGo="true"
        :orderId="orderId"
        :originPage="originPage"
        :price="orderGoodsPaymentPrice"
        :specids="specids"
        :store-id="storeId"
        @changeVisible="(val) => (isShowPay = val)"
        @clickPay="uploadClose"
    ></Pay>
    <select-coupon
        :couponList="couponList"
        :goodsids="goodsids"
        :visible="showCoupon"
        @change="getCouponId"
        @close="showCoupon = false"
    ></select-coupon>
  </div>
</template>
<script>
import _ from 'lodash';
import FixedHeader from 'components/common/FixedHeader';
import GoodsTags from 'components/common/GoodsTags';
import Pay from 'components/common/Pay';
import SelectCoupon from 'components/common/SelectCoupon';
import MySwitch from 'components/common/Switch';
import { mapMutations, mapState } from 'vuex';
import * as userApis from 'apis/user';
import * as orderApis from 'apis/order';
import * as couponApis from 'apis/coupon';
import { showAddress } from 'utils/order';
import DataStorage from 'utils/dataStore';
import { dateFormater } from 'utils/date';
import { getCookie } from 'utils/index';
import {
  beforeRouteChange,
  getDevicePlatForm,
  getGoodsSizeNum,
  initCloseUpload,
  uploadAccessData,
  uploadCloseData,
  uploadSubmitOrder,
} from 'utils/uploadData';
import MgtvApi from 'MgtvApi';
import Env from 'utils/env';
import MgStat from 'MgStat';

export default {
  components: {
    FixedHeader,
    Pay,
    MySwitch,
    SelectCoupon,
    GoodsTags,
  },
  data() {
    // address_id是从地址管理页面带过来
    const {
      query: { addressId },
    } = this.$route;
    return {
      nowAddressId: addressId ? Number(addressId) : 0,
      isEdit: false,
      isSelectAll: false,
      isShowPay: false,
      orderId: 0,
      originPage: this,
      errorMsg: '',
      nowAddress: {
        consignee: '',
        mobile: '',
        province: {
          id: '',
          name: '',
        },
        city: {
          id: '',
          name: '',
        },
        district: {
          id: '',
          name: '',
        },
        address: '',
        addressId: 0,
        isDefault: false,
        gbType: 0,
      },
      hasNoAddress: 1,
      userIntegral: 0,
      showPayBtn: true,
      form: {
        cartList: [],
        couponPrice: 0, // 优惠券抵扣
        discountPrice: 0, // 折扣价格
        goodsNum: 0, // 订单商品总数
        goodsPrice: 0, // 订单商品总价
        integral: 0, // 积分价格
        integralPrice: 0, // 积分抵扣价格
        payableAmount: 0, // 应付金额
        promotionPrice: 0, // 活动抵扣
        shippingPrice: 0, // 快递费用
        balancePrice: 0, // 余额抵扣
      },
      preSellInfo: null,
      hasAnyAction: false,
      hasRouteChange: false,
      hasCoupon: 1,
      showCoupon: false,
      couponId: 0,
      couponPrice: 0,
      couponSaleType: 1,
      couponName: '',
      couponList: [],
      goodsids: '',
      goodsidsAndNum: '',
      specids: '',
      isBlindBoxGoods: false,
      showSelectCoupon: true,
      showAddressFlag: true,
      goodsFrom: '0',
      virtualGoodJumpLinkFlag: false,
      virtualGoodJumpLinkArray: [1, 3, 4, 5, 6],
    };
  },
  watch: {
    hasAnyAction: {
      handler(val) {
        DataStorage.setPageVisitiLog(val);
      },
      immediate: true,
    },
    showCoupon: {
      handler(val) {
        if (val) {
          MgStat.send(
            'cv',
            {
              couponid: this.couponId,
              goods_id: this.goodsids,
            },
            {
              mod: 'c_hwcouponpop',
            },
          );
        }
      },
      immediate: true,
    },
    userIntegral: {
      handler(val) {
        const { from = '' } = this.$route.query;
        if (val < this.form.integral && (from === 'jifen_shop_home' || from === 'jubaopen_shop_home')) {
          this.showPayBtn = false;
        }
      },
    },
  },
  computed: {
    ...mapState('pay', [
      'userNote',
      'noticeMobile',
      'is_agree_rule',
      'is_agree_box_rule',
      'buyNowInfo',
    ]),
    fromJubaopen() {
      return this.$route.query.from === 'jubaopen_shop_home';
    },
    hasAddress() {
      const { nowAddress } = this;
      return nowAddress && nowAddress.addressId;
    },
    couponTip() {
      const {
        couponList, couponPrice, couponSaleType, couponName,
      } = this;
      const list = couponList.filter(f => f.available);
      const len = list.length;
      if (couponSaleType === 2) {
        return couponName;
      }
      if (couponPrice) {
        return `优惠¥${this.form.couponPrice}`;
      }
      return len ? `有${len}张可用` : '无可用';
    },
    preBuyTime() {
      const {
        preSellInfo: { retainageStart },
      } = this;
      return dateFormater(retainageStart * 1000, 'MM-dd hh:mm');
    },
    preBuyDepositPrice() {
      const {
        preSellInfo: { deposit },
        form: { goodsNum },
      } = this;
      return (goodsNum * Number(deposit)).toFixed(2) || null;
    },
    preBuyCutPrice() {
      const {
        form: { goodsPrice, payableAmount },
      } = this;
      return Number(goodsPrice - payableAmount).toFixed(2) || null;
    },
    // 计算结算单商品总价
    orderGoodsTotalPrice() {
      const { form } = this;
      if (form.integral) {
        if (form.payableAmount) {
          return `${form.integral}${this.coinName} + ¥ ${form.payableAmount}`;
        }
        return `${form.integral}${this.coinName}`;
      }
      // 纯积分
      return `¥${form.goodsPrice}`;
    },
    // 计算结算单应付总价
    orderGoodsPaymentPrice() {
      const { form } = this;
      if (form.integral) {
        if (form.payableAmount) {
          return `${form.integral}${this.coinName} + ¥ ${form.payableAmount}`;
        }
        return `${form.integral}${this.coinName}`;
      }
      // 纯积分
      return `¥${form.payableAmount}`;
    },
    storeId() {
      const { buyNowInfo: { storeId } } = this;
      return storeId;
    },
  },
  async created() {
    const { buyNowInfo } = this;
    const isFromCart = sessionStorage.getItem('fromCart');
    const isWeixinPay = Env.isWeixin && sessionStorage.getItem('weixinParams');
    if (isWeixinPay) {
      return;
    }
    if (!isFromCart && !buyNowInfo && !isWeixinPay) {
      //  如果不是以上入口进来 则往上跳一级
      this.$router.go(-1);
      return;
    }
    await this.fetchCreateSettlement();
    await this.fetchPriceInfo();
    await this.fetchAddressList();
    this.getUserIntegral();
  },
  mounted() {
    initCloseUpload();
  },
  beforeRouteLeave(to, from, next) {
    if (!this.hasRouteChange) {
      uploadCloseData();
    }
    next();
  },
  methods: {
    showAddress,
    ...mapMutations('pay', [
      'changeUserNote',
      'changeMobile',
      'changePreRule',
      'changeBoxRule',
      'clearNoteData',
    ]),
    // 获取结算单商品信息
    async fetchCreateSettlement() {
      let data = null;
      const { buyNowInfo } = this;
      // 盲盒产品
      if (_.has(buyNowInfo, 'isBlindBoxGoods')) {
        this.isBlindBoxGoods = buyNowInfo.isBlindBoxGoods;
      }
      // 预售信息
      if (_.has(buyNowInfo, 'preSellInfo')) {
        this.preSellInfo = buyNowInfo.preSellInfo;
        _.unset(buyNowInfo, 'preSellInfo');
      }
      // 全局使用
      _.assign(this.buyNowInfo, buyNowInfo);
      try {
        if (!_.isEmpty(buyNowInfo)) {
          // 如果是立即购买
          data = await orderApis.getOrderSettleInfo(buyNowInfo);
        } else {
          // 如果是从购物车页面进来
          data = await orderApis.getOrderSettleInfo();
        }
        if (!_.isEmpty(data)) {
          const cartList = data;
          _.assign(this.form, { cartList });
          const goodsSpecList = [];
          const goodsIdList = [];
          const goodsIdAndNumList = [];
          const specIdList = [];
          cartList.forEach((f) => {
            goodsSpecList.push({
              goodsId: f.goodsId,
              goodsNum: f.goodsNum,
              specKey: f.specKey,
            });
            goodsIdList.push(f.goodsId);
            goodsIdAndNumList.push(`${f.goodsId}_${f.goodsNum}`);
            if (f.specKey) {
              specIdList.push(f.specKey);
            }
            if (f.isVirtual) {
              this.showAddressFlag = false;
              if (f.virtualType === 0 && this.virtualGoodJumpLinkArray.indexOf(f.virtualCouponType) !== -1) {
                this.virtualGoodJumpLinkFlag = true;
              }
            }
            this.goodsFrom = f.goodsFrom;
          });
          this.goodsids = goodsIdList.join(',');
          this.goodsidsAndNum = goodsIdAndNumList.join(',');
          this.specids = specIdList.join(',');
          this.fetchCouponInfo(goodsSpecList);
          uploadAccessData(getGoodsSizeNum(cartList));
        }
      } catch (error) {
        const { message } = error;
        if (error.message.indexOf('地址') !== -1) {
          this.errorMsg = message;
        } else {
          this.errorMsg = '';
          this.$toast({ message, duration: 2000 });
        }
      }
    },
    // 获取结算单中邮费及支付金额等信息
    async fetchPriceInfo() {
      const { nowAddressId, buyNowInfo, couponId } = this;
      const val = buyNowInfo || {};
      if (nowAddressId) {
        _.assign(val, {
          addressId: nowAddressId,
        });
      }
      if (couponId) {
        _.assign(val, {
          couponId,
        });
      }
      try {
        const data = await orderApis.getOrderCalculateInfo(val);
        if (!_.isEmpty(data)) {
          _.assign(this.form, data);
        }
      } catch (error) {
        const { message } = error;
        if (message.indexOf('地址') !== -1) {
          this.errorMsg = message; // 地址错误就特殊提示一下
        } else {
          this.errorMsg = '';
          this.$toast({ message, duration: 2000 });
        }
      }
    },
    // 选择优惠券后回调
    async getCouponId({
      id, price, sale_type, name,
    }) {
      this.couponSaleType = sale_type;
      this.couponId = id;
      this.couponPrice = price;
      this.couponName = name;
      this.showCoupon = false;
      if (!id) {
        const { buyNowInfo: param } = this;
        if (param && param.couponId) {
          param.couponId = 0;
          _.assign(this.buyNowInfo, param);
        }
      }
      this.fetchPriceInfo();
    },
    // 创建订单
    async readyPay() {
      const {
        nowAddressId,
        userNote,
        buyNowInfo,
        preSellInfo,
        is_agree_rule,
        errorMsg,
        isBlindBoxGoods,
        is_agree_box_rule,
        couponId,
        noticeMobile,
        showAddressFlag,
      } = this;
      this.hasAnyAction = true;
      if (errorMsg) {
        this.$toast({ message: '订单信息有误', duration: 1000 });
      }
      if (showAddressFlag && !nowAddressId) {
        this.$toast({ message: '请填写地址', duration: 1000 });
        return;
      }
      // 企业购商品购买时，硬核要求必须更新为最新的地址
      if (showAddressFlag && this.nowAddress.gbType !== 1) {
        this.$toast({ message: '地址库已更新，请重新填写地址哦', duration: 1000 });
        return;
      }
      if (preSellInfo && !is_agree_rule) {
        this.$toast({
          message: '请勾选同意定金不退规则，否则无法进行下一步',
          duration: 2000,
        });
        return;
      }
      if (isBlindBoxGoods && !is_agree_box_rule) {
        this.$toast({
          message: '请勾选同意盲盒不退款规则，否则无法进行下一步',
          duration: 2000,
        });
        return;
      }
      this.$loading.open();
      // 来源信息
      const uploadParams = DataStorage.getFixedUploadParams();
      const platform = getDevicePlatForm();
      try {
        const submitForm = {
          act: 'submit_order',
          addressId: nowAddressId,
          platform,
          userNote,
          goodsFrom: this.goodsFrom,
        };
        if (uploadParams) {
          submitForm.from = uploadParams.from || '';
          submitForm.entry = uploadParams.entry || '';
          submitForm.propb = uploadParams.propb || '';
          submitForm.did = uploadParams.uid || '';
        }
        if (_.isEmpty(submitForm.did)) {
          submitForm.did = getCookie('mba_deviceid');
        }
        // 通知手机
        if (!_.isEmpty(noticeMobile)) {
          _.assign(submitForm, { noticeMobile });
        }
        // 优惠券
        if (couponId) {
          _.assign(submitForm, { couponId });
        }
        // 立即购买或者购物车购买
        if (!_.isEmpty(buyNowInfo)) {
          // 立即购买
          _.assign(submitForm, buyNowInfo);
        }
        if (this.goodsFrom === 'linkedMall' || this.goodsFrom === 'jdMall') {
          // 积分商品先确定当前地区是否支持购买，并且预下单，预下单失败，直接返回失败不在平台进行下单处理
          const channelOrderId = await orderApis.renderJiFenOrder(submitForm);
          if (channelOrderId) {
            submitForm.channelOrderId = channelOrderId;
          } else {
            this.$toast({
              message: '下单失败,请稍后重试',
              duration: 2000,
            });
            return;
          }
        }

        const orderId = await orderApis.submitOrder(submitForm, 'submit_order');
        this.orderId = orderId;
        MgStat.send(
          'click',
          {
            order_id: this.orderId,
            status: 0,
          },
          {
            mod: 'confrim_payment',
            cont: '订单结果',
            direct: 'cntp',
            label: 'text',
            cntp: 'haowu_pay',
          },
        );
        sessionStorage.removeItem('fromCart');
        this.uploadOrderData();
        // 订单创建成功后
        if (this.form.payableAmount <= 0) {
          // 使用优惠券后价格为0  直接去订单列表 无需支付
          this.clearNoteData();
          if (this.virtualGoodJumpLinkFlag) {
            // 不需要显示地址的为虚拟订单,直接去到订单详情页
            this.gotoOrderDetail(this.orderId);
          } else {
            // 实体商品订单，去订单列表
            this.gotoOrderAll();
          }
        } else {
          this.isShowPay = true;
        }
      } catch (error) {
        this.$toast(`订单创建失败:${error.message}`);
        MgStat.send(
          'click',
          {
            order_id: this.orderId,
            status: 1,
          },
          {
            mod: 'confrim_payment',
            cont: '订单结果',
            direct: 'cntp',
            label: 'text',
            cntp: 'haowu_pay',
          },
        );
      }
      this.$loading.close();
    },
    // 获取用户地址
    async fetchAddressList() {
      const data = await userApis.getAddressList();
      if (Array.isArray(data)) {
        let adderss;
        if (!this.nowAddressId) {
          /* 没有id则用默认值 */
          [adderss] = data.filter(f => f.isDefault);
        } else {
          [adderss] = data.filter(f => f.addressId === this.nowAddressId);
          if (!adderss) {
            /* 如果没匹配到数据 说明地址被删除了 */
            this.$router.replace('/pay');
            /* 安卓端 页面刷新 title就会变化 所以在此需要再执行一遍 */
            MgtvApi.setWebviewTitle({ title: '芒果好物' });
            this.nowAddressId = 0;
          }
        }
        if (!_.isEmpty(adderss)) {
          this.nowAddressId = adderss.addressId;
          this.nowAddress = adderss;
          if (!this.noticeMobile) {
            this.changeMobile(adderss.mobile);
          }
        }
        if (!data.length) {
          this.hasNoAddress = 1;
        } else {
          this.hasNoAddress = 0;
        }
      }
    },
    // 获取优惠券信息
    async fetchCouponInfo(list) {
      try {
        const data = await couponApis.getCouponList({
          param: JSON.stringify(list),
        });
        if (Array.isArray(data)) {
          this.couponList = data;
        }
      } catch (error) {
        this.$toast(`获取优惠券失败：${error.message}`);
      }
    },
    // 广告上报
    uploadOrderData() {
      const {
        orderId: orderid,
        form: { cartList, totalAmount: price },
      } = this;
      uploadSubmitOrder({ orderid, price, ...getGoodsSizeNum(cartList) });
    },
    // 去到订单详情页
    gotoOrderDetail(id) {
      beforeRouteChange({
        path: '/order/detail',
        query: { id },
      }, this);
    },
    // 去到订单所有页
    gotoOrderAll() {
      beforeRouteChange({ path: '/order/all' }, this);
    },
    // 获取邮费信息
    getTransway(val) {
      if (typeof val === 'number') {
        if (!val) {
          return '快递包邮';
        }
        return `¥${val}`;
      }
      return '-';
    },
    // 编辑地址
    gotoEdit() {
      if (this.hasNoAddress) {
        beforeRouteChange(
          { path: '/address/edit', query: { first_add: 1 } },
          this,
        );
      } else {
        beforeRouteChange({ path: '/address/manage' }, this);
      }
    },
    // 获取商品价格
    getGoodsPrice(val) {
      const {
        preSellInfo: { salePrice },
      } = this;
      return salePrice || val;
    },
    getDiscountPrice(val) {
      const {
        form: { goodsNum },
      } = this;
      return goodsNum && val ? (goodsNum * Number(val)).toFixed(2) : null;
    },
    async uploadClose(callback) {
      // 支付成功回来之后 路由会变化 但是支付的时候已经上报了  所以设置为true 不再上报
      this.hasRouteChange = true;
      await uploadCloseData();
      if (typeof callback === 'function') {
        callback();
      }
    },
    getItemPrice({
      exchangeIntegral,
      exchangePrice,
      memberGoodsPrice,
      goodsPrice,
    }) {
      // 积分购买
      if (exchangeIntegral) {
        // 积分+现金购
        if (exchangePrice) {
          return `${exchangeIntegral}${this.coinName} + ${exchangePrice} 元`;
        }
        this.showSelectCoupon = false;
        // 纯积分
        return `${exchangeIntegral}${this.coinName}`;
      }
      // 纯现金
      this.showSelectCoupon = true;
      return memberGoodsPrice || goodsPrice;
    },
    async getUserIntegral() {
      if (this.fromJubaopen) {
        this.userIntegral = await userApis.getUserJbpCoin(); // 聚宝盆金币
      } else if (this.form.integral) {
        this.userIntegral = await userApis.getUserIntegral(); // 积分
      }
    },
  },
};
</script>

<style lang="scss">
.pay {
  height: 100%;

  &__main {
    height: 100%;
    box-sizing: border-box;
    padding: 0 30px 98px 30px;
  }

  &__address {
    padding: 34px 26px;
    background: #ffffff;
    border-radius: 20px;
    margin: 30px 0px 0px 0px;

    &-user {
      font-size: 28px;
      color: #000000;
      margin-bottom: 20px;
    }

    &-detail {
      display: flex;
      align-items: center;

      div:nth-child(1),
      div:nth-child(3) {
        width: 30px;
      }

      div:nth-child(2) {
        flex: 1;
        font-size: 30px;
        margin: 0 40px;
        color: #000000;
      }
    }

    &-error {
      font-size: 20px;
      color: #f47125;
      padding: 10px 60px 0 60px;
      word-break: break-all;
    }
  }

  &__content {
    margin-top: 20px;
    margin-bottom: 30px;
    padding: 20px 26px;
    background: #ffffff;
    border-radius: 20px;

    &-sku {
      padding: 24px 0;
      display: flex;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);

      section:nth-child(1) {
        width: 170px;
        height: 170px;
        margin-right: 30px;

        img {
          height: 100%;
          max-width: 100%;
        }
      }

      section:nth-child(2) {
        flex: 1;

        div:nth-of-type(1) {
          font-size: 28px;
          color: #000000;
          margin-bottom: 14px;
        }

        div:nth-of-type(2) {
          font-size: 26px;
          color: #4a4a4a;
          margin-bottom: 14px;
        }

        div:nth-of-type(3) {
          display: flex;
          justify-content: space-between;
          align-items: center;

          span:nth-child(1) {
            font-size: 32px;
            color: #ff4c00;
          }

          span:nth-child(2) {
            font-size: 24px;
            color: #99948e;
          }
        }
      }
    }

    &-transway {
      display: flex;
      justify-content: space-between;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);
      padding: 0 8px;
      height: 68px;
      line-height: 68px;
      font-size: 24px;
      color: #000000;
    }

    &-coupon {
      @extend .pay__content-transway;

      .checked {
        display: inline-block;
        border-radius: 4px;
        font-size: 18px;
        padding: 5px 3px;
        text-align: center;
        margin-left: 16px;
        line-height: 1;
        color: #ff4c00;
        border: 2px solid #ff4c00;
      }

      div:last-of-type {
        display: flex;
        align-items: center;

        span {
          &.active {
            color: #ff4c00;
          }
        }

        i {
          margin-left: 20px;
        }
      }
    }

    &-remark {
      @extend .pay__content-transway;

      div:first-child {
        width: 114px;
        margin-right: 30px;
      }

      div:last-child {
        flex: 1;

        input {
          font-size: 24px;
          padding-right: 20px;
          box-sizing: border-box;
        }
      }
    }

    &-price {
      @extend .pay__content-transway;
      border: none;
      justify-content: flex-end;

      div + div {
        margin-left: 20px;
      }

      span:last-child {
        color: #ff4c00;
        font-weight: 600;
      }
    }
  }

  &__presell {
    border-radius: 20px;
    background: #fff;
    padding: 20px 30px;
    margin: 20px 0px;

    &-phone {
      display: flex;
      justify-content: center;
      font-size: 22px;
      line-height: 30px;
      white-space: nowrap;
      padding-bottom: 20px;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);
    }

    &-tip {
      p {
        font-size: 22px;

        &:nth-of-type(1) {
          color: #ff5400;
          margin: 20px 0 26px 0;
          font-weight: bold;
        }

        &:nth-of-type(2) {
          display: flex;
          justify-content: space-between;
        }
      }
    }

    &-info {
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);

      p {
        display: flex;
        justify-content: space-between;
        margin: 20px 0;
        font-size: 22px;

        &:nth-of-type(1) {
          span:last-of-type() {
            color: #ff5400;
          }
        }
      }
    }
  }

  &__price {
    border-radius: 20px;
    background: #fff;
    padding: 0px 30px;
    margin: 20px 0px;
    font-size: 22px;

    .active {
      color: #ff5f00 !important;
    }

    li {
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);

      &:last-of-type {
        border: none;

        span {
          &:first-of-type {
            color: #000000;
          }
        }
      }

      span {
        &:first-of-type {
          color: #4a4a4a;
        }

        &:last-of-type {
          color: #000000;
        }
      }
    }
  }

  &__order-tip {
    background: #fff;
    border-radius: 20px;
    padding-left: 30px;
    overflow: hidden;
    @extend .pay__content-remark;
  }

  &__integral-tip {
    background: #fff;
    border-radius: 20px;
    padding-left: 30px;
    overflow: hidden;
    margin-top: 15px;
    margin-bottom: 180px;
    @extend .pay__content-remark;
  }

  &__bottom {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    background: #fff;
    font-size: 30px;

    div {
      height: 98px;
      line-height: 98px;
    }

    div:first-child {
      padding: 0 30px;
      flex: 1;
      color: #000000;

      span {
        color: #ff4c00;
        font-weight: 600;
      }
    }

    div:last-child {
      width: 280px;
      background: #ff5f00;
      color: #fff;
      text-align: center;
    }
  }
}
</style>
